<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import Rapor from "./Rapor.vue";
import BirimIyılestirmeleri from "./BirimIyılestirmeleri.vue"
import StrIsoIzlemKriterleri from "@/models/StrIsoIzlemKriterleri"; import Swal from "sweetalert2";
import forminput from "@/router/views/FormComponet/forminput.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiFilter.vue";
export default {
  mixins: [Api, Sabit, StrIsoIzlemKriterleri],
  page: {
    title: "İyileştirmeler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit, forminput, BirimSecimi, BirimIyılestirmeleri, Rapor
  },
  data() {
    return {
      title: "İzleme Kriterleri ",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kalite Yönetim Sistemi (ISO 9001) Çalışmaları",
        },
        {
          text: "İzleme Kriterleri ",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter: {
        Birimid: null,
        Onay: null,
      },
      Kriterid: null,
      KaliteRoleKontrol:false, 
    };
  },

  methods: {
    Get() {
      var Filter = ""

      if (this.Filter.Birimid != null) { Filter += "&Birimid=" + this.Filter.Birimid }
      if (this.Filter.Onay != null) { Filter += "&Onay=" + this.Filter.Onay }

      this.ActionsFilterGet({ Service: "StrIsoIzlemKriterleri", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    OnayDegistir(Data, durum) {
      Swal.fire({
        title: "Onay " + (durum == false ? 'İptal' : ''),
        text: "Seçtiğiniz izleme kriteri onay durumu değiştiriliecek.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Onay = durum
          this.Update("StrIsoIzlemKriterleri", Data, "Onay durumu değiştirildi")
        }
      });

    },
    
    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin") || item.includes("StrAdmin") || item.includes("StrIsoKaliteTemsilci")
      );
      if (YetkiSorgu.length != 0) this.KaliteRoleKontrol = true; 
    },
  },
  created(){
    
    this.MuneRolesControl();
  }
};
</script>
<style scoped >
.action-is i {
  margin: 0 10px;   
  font-size: 16px; 
  line-height: 1;  
  vertical-align: middle;
}

</style>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">



                <BirimSecimi class="mb-3 col-md-3" :title="FormDataType.Birimids.FieldTitle" :sutun="'0'"
                  :title_position="'mb-3'" :selected="Filter.Birimid" :labels_lg="'3'" :v="$v.Filter.Birimid"
                  :multiple="false" :BirimTipId="null" @Secilmis_Idler="Filter.Birimid = $event" />
                <forminput class="col-md-3" :FormDataType="FormDataType.Onay" :Value="Filter.Onay" :v="$v.Filter.Onay"
                  @input="Filter.Onay = $event" />
                <forminput class="col-md-3" :FormDataType="FormDataType.Kriter" :Value="Filter.Kriter"
                  :v="$v.Filter.Kriter" @input="Filter.Kriter = $event" />

                <div class="col-sm-2 ">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4" @click="Get()"> <i
                      class="mdi mdi-text-search me-1"></i>Filtreleme</button>
                </div>


                <div class="col-sm-4 ">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2 mt-4"
                      v-b-modal.StrIsoIzlemKriterleri
                      @click="(DataUpdate = StrIsoIzlemKriterleriData), (AddEdit = 'Add')"><i
                        class="mdi mdi-plus me-1"></i>Yeni Kayıt Ekle</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Süreç</th>
                      <th>Sorumlu Birimler</th>
                      <th>İzleme Kriteri No</th>
                      <th>İzleme Kriteri</th>
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Surec }}</th>
                      <td>{{ Data.Birimler }}</td>
                      <td>{{ Data.No }}</td>
                      <td>{{ Data.Kriter }}</td><td>
  <div class="d-flex justify-content-center align-items-center gap-2 flex-wrap">

    <!-- Rapor -->
    <button class="btn btn-sm btn-light rounded-circle shadow-sm"
            v-b-modal.Rapor
            @click="Kriterid = Data.Id"
            v-b-tooltip.hover
            title="Raporu Görüntüle">
      <i class="fas fa-eye text-primary"></i>
    </button>

    <!-- Birim İyileştirmeleri -->
    <button class="btn btn-sm btn-light rounded-circle shadow-sm"
            v-b-modal.BirimIyılestirmeleri
            @click="Kriterid = Data.Id"
            v-b-tooltip.hover
            title="Birim İyileştirmeleri">
      <i class="fas fa-search text-info"></i>
    </button>

    <!-- Onay & Onay Kaldır -->
    <button v-if="!Data.Onay && Data.Birimids.length != Data.Tamamlayanbirimsayisi"
            class="btn btn-sm btn-light rounded-circle shadow-sm"
            @click="OnayDegistir(Data, true)"
            v-b-tooltip.hover
            title="Onayla">
      <i class="fas fa-check text-success"></i>
    </button>

    <button v-if="Data.Onay && Data.Birimids.length != Data.Tamamlayanbirimsayisi"
            class="btn btn-sm btn-light rounded-circle shadow-sm"
            @click="OnayDegistir(Data, false)"
            v-b-tooltip.hover
            title="Onayı Kaldır">
      <i class="fas fa-times text-warning"></i>
    </button>

    <!-- Düzenle -->
    <button v-if="Data.Birimids.length != Data.Tamamlayanbirimsayisi"
            class="btn btn-sm btn-light rounded-circle shadow-sm"
            v-b-modal.StrIsoIzlemKriterleri
            @click="(DataUpdate = Data), (AddEdit = 'Edit')"
            v-b-tooltip.hover
            title="Düzenle">
      <i class="fas fa-pencil-alt text-secondary"></i>
    </button>

    <!-- Sil -->
    <button v-if="Data.Birimids.length != Data.Tamamlayanbirimsayisi && KaliteRoleKontrol"
            class="btn btn-sm btn-light rounded-circle shadow-sm"
            @click="Delete('StrIsoIzlemKriterleri', Data.Id)"
            v-b-tooltip.hover
            title="Sil">
      <i class="fas fa-trash-alt text-danger"></i>
    </button>

    <!-- Tamamlandı -->
    <span v-else class="badge bg-success d-flex align-items-center gap-1 px-3 py-2">
      <i class="fas fa-check-circle"></i> Tamamlandı
    </span>

  </div>
</td>


                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
      <BirimIyılestirmeleri :Id="Kriterid" />
      <Rapor :Id="Kriterid" />



    </Layout>
  </Loader>
</template>
